<template>
<div>
  <Alert  text="PLANO GRATUITO"
      callbackText="ASSINAR"
      :callback="() => $router.push({ path: '/assinatura/planos' })"
      :plan="true"
      :backButton="true"
 />
       <div class="row " style="height: 56vh">
     <div class="col-md-6 d-sm-none h-100 img-login" :style="`background-image: url('https://bucketrecreativa.s3.amazonaws.com/coruja.png')`">
    </div>
    <div class="col-md-6 d-flex flex-column justify-content-center align-items-center">
      <div class="text-center mb-3">
          <span class="label mb-5">insira um e-mail abaixo para que possamos recuperar sua senha. </span>
      </div>
      <div class="card" style="width: 65%">
        <Input title="E-mail de recuperação" v-model="recovery_email" />
        <button @click="recoveryEmail" class="btn-login">Enviar e-mail</button>
      </div>
    </div>
  </div>
  <Alert text="VEJA AS NOVIDADES!" />
    <SliderBottom />
</div>
 
</template>

<script>
import { validator } from "../assets/js/util";
import Input from '../components/Input'
import Alert from '../components/AlertaPlano'
import SliderBottom from '../components/SliderBottom'
export default {
  name: "Recovery",
  components:{
    Input,
    Alert,
    SliderBottom
  },
  data: () => ({
    recovery_email: ''
  }),
  methods: {
    recoveryEmail: function () {
      this.$store.commit('loading', true)
      if (this.recovery_email != "") {
        if (validator("email", this.recovery_email)) {
          this.$axios
            .get(`/users/${this.recovery_email}/redefinir_senha`)
            .then((res) => res.data)
            .then(() => {
                    this.$store.commit('loading', false)

              this.$store.commit("setStateModal", {
                visible: true,
                title: "Sucesso",
                type: "success",
                message: `Um e-mail foi enviado a, ${this.recovery_email}, com as informações de recuperação.`,
              });
                            this.recovery_email = ''

            })
            .catch((e) => {
                                  this.$store.commit('loading', false)

              this.$store.commit("setStateModal", {
                visible: true,
                title: "ATENÇÃO",
                type: "warning",
                message: e.response.data.message,
              });
            });
        } else {
          this.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "warning",
            message: "Verifique se o e-mail digitado é válido.",
          });
        }
      } else {
        this.$store.commit("setStateModal", {
          visible: true,
          title: "ATENÇÃO",
          type: "warning",
          message: "Verifique se o campos foram digitados corretamente.",
        });
      }
    },
  },
};
</script>

<style scoped>
.card{
    border: none;
    padding: 30px 40px;
    box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.200);
    border-radius: 0;
    font-size: 14px !important;
    position: relative;
}

.btn-login{
  width: 100%;
  height: 50px;
  bottom: -50px;
  left: 0;
  border: none;
  font-size: 18px;
  background-color: #8d4d9a;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
  position: absolute;
  text-transform: uppercase;
  transition: ease .5s;
}

.btn-login:hover{
  transform: scale(1.05);
}

.label{
  font-size: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
}
</style>